import { AffiliateLinksCopy } from "@lib/constants";
import { Button, Divider, Space } from "antd";

interface AffiliateLinksProps {
    className?: string;
    attrs: any;
}

const AffiliateLinks = ({ className, attrs }: AffiliateLinksProps) => {
    const css: any = ["covr-affiliate-links"];

    if (className) {
        css.push(className);
    }

    return (
        <>
            <Space className={css} wrap size={0}>
                {attrs.ebayUrl && <Button
                    type={`link`}
                    className="btn"
                    href={attrs.ebayUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {AffiliateLinksCopy.EBAY}
                </Button>}
                {attrs.mycomicshopUrl && attrs.ebayUrl && <Divider type={`vertical`} />}
                {attrs.mycomicshopUrl && <Button
                    type={`link`}
                    className="btn"
                    href={attrs.mycomicshopUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {AffiliateLinksCopy.MCS}
                </Button>}
                {attrs.thirdEyeUrl && (attrs.mycomicshopUrl || attrs.ebayUrl) && <Divider type={`vertical`} />}
                {attrs.thirdEyeUrl && <Button
                    type={`link`}
                    className="btn affiliate-link-third_eye"
                    href={attrs.thirdEyeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {AffiliateLinksCopy.THIRD_EYE}
                </Button>}
            </Space>
            <p className="covr-affiliate-disclosure mar-bot-15">Affiliate disclosure: This site contains affiliate links for which we may be compensated.</p>
        </>
    );
};

export default AffiliateLinks;
